import React from "react";
import styled from "@emotion/styled";
import Lottie from "lottie-react";
import { Flex } from "styles/utility-components";

import loadingAnimation from "./loadingAnimation.json";

export default function BidReportLoadingState() {
  return (
    <Container>
      <Animation animationData={loadingAnimation} />
    </Container>
  );
}

const Container = styled(Flex)({
  justifyContent: "center",
  width: "100%",
  // If the current user is logged in, the display is a little
  // different. This just ensures central vertical alignment
  height: window.currentUser ? "100%" : "85vh",
  alignItems: "center",
});

const Animation = styled(Lottie)({
  height: "30vh",

  textAlign: "center",
  "@media (max-width: 1400px)": {
    height: "45vh",
  },
});
